import React, {useState, useEffect} from "react";
import { LoadingSpinner } from "../../../components/dashboard/partials/LoadingSpinner";
import { OBJECT_EMPTY } from "../../../helpers";
import { FileImportTable } from "../../Global/FileImportTable/FileImportTable";

import "./FileImport.css";

export const FileImport = () => {
  const [dataLoaded, setDataLoaded] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  return (
    <div className="FileImport">

      <div className="Dashboard__content__top-row">
        <h2>File Import</h2>
      </div>

      <FileImportTable />
    </div>
  );
};
